// map containing the events that will be tracked once a given survey page is visited:
// the key is the page number of our survey, the value represents the tracking event
export const TRACKING_PAGE_EVENT_MAP = {
  '-2': '1_landing_page',
  0: '3_regular_signup_form',
  1: 'symptoms_questions_list',
  2: '5_see_if_eligible_page',
  3: '12_gi_symptoms_question',
  'assessment-a': '13_assessment_A',
  'assessment-b': '13_assessment_B',
  'assessment-c': '13_assessment_C',
  'assessment-d': '13_assessment_D',
  4: 'testimonial',
  5: '6_sex_and_gender_question',
  6: '7_ethnicity_question',
  7: '8_pregnancy_question',
  8: '9_eating_disorder_question',
  9: '10_gi_surgery_question',
  10: '18_last_step_page',
};

// the following events are not bounded to any specific survey page,
// so they are not in the map above but the live independently
export const TRACKING_START_SIGN_UP = 'signup_start';
export const TRACKING_SIGN_UP_SUCCEDEED = 'signup_succeeded';
export const TRACKING_SIGN_UP_FAILED = 'signup_failed';
export const TRACKING_PREGNANCY_REJECT = 'user_ineligible_3';
export const TRACKING_DISORDER_REJECT = 'user_ineligible_4';
export const TRACKING_GI_SURGERY_REJECT = 'user_ineligible_5';
export const TRACKING_MEMBERSHIP_PAGE = 'choose_membership';
export const TRACKING_STRIPE_PAYMENT_PAGE = 'stripe_payment_page';
export const TRACKING_DOWNLOAD_APP_PAGE = 'download_app_page';
export const TRACKING_FREE_CONSULTATION_LINK_CLICK = 'click_for_consultation';
export const TRACKING_FREE_CONSULTATION_HOME_LINK_CLICK =
  'home_click_for_consultation';
export const TRACKING_ELIGIBILITY_CHECK = 'check_member_eligibility';
export const TRACKING_CARD_SCAN_START = 'card_scan_start';
export const TRACKING_CARD_SCAN_SUCCESS = 'card_scan_success';
export const TRACKING_CARD_SCAN_FAILED = 'card_scan_fail';
export const TRACKING_PURCHASE_LOCAL_STORAGE_KEY = 'finishedOnboarding';

// Events used for tracking in GTM
export const TRACKING_ONBOARDING_STARTED = 'Onboarding Started';
export const TRACKING_ONBOARDING_COMPLETED = 'Create account';
export const TRACKING_PLANS_SCREEN = 'Select plan';
export const TRACKING_INITIATE_CHECKOUT = 'Go To Checkout';
export const TRACKING_ELIGIBILITY_CHECK_SCREEN = 'Eligibility Check Screen';
export const TRACKING_PURCHASE = 'Thank You';
